import { $, $$ } from '@utils';
import lottie from 'lottie-web';

function init() {
  if (!$('[data-au-simple-hero-form]')) return;

  loadStateLotties();
}

function loadStateLotties() {
  $$('[data-au-simple-hero-form-lottie]').forEach((container) => {
    const path = container.dataset.auSimpleHeroFormLottie;
    if (!path) return;

    lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path,
    });
  });
}

export default { init };
